'use client';

import { faqCategories } from '@repo/config';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@repo/ui';
import { Container } from '@repo/web-chrome/components/container';
import { Link } from '@repo/web-chrome/components/link';
import { Heading, Subheading } from '@repo/web-chrome/components/text';

const previewItems = faqCategories.flatMap((c) => c.items).slice(0, 6);

interface IHelpFaqPreviewProps {
  subheading: string;
  title: string;
  viewAll: string;
}

export const HelpFaqPreview = ({
  subheading,
  title,
  viewAll,
}: IHelpFaqPreviewProps): React.JSX.Element => {
  return (
    <Container className="py-12 sm:py-16">
      <div className="text-center mb-12">
        <Subheading>{subheading}</Subheading>
        <Heading as="h2" className="mt-2">
          {title}
        </Heading>
      </div>
      <div data-reveal="up" className="mx-auto max-w-3xl">
        <Accordion type="multiple" className="rounded-2xl border border-border">
          {previewItems.map((item) => (
            <AccordionItem key={item.question} value={item.question}>
              <AccordionTrigger className="px-6 text-start">{item.question}</AccordionTrigger>
              <AccordionContent className="px-6 text-muted-foreground">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        <div className="mt-6 text-center">
          <Link
            href="/faq"
            className="text-sm font-semibold text-foreground hover:text-muted-foreground transition-colors"
          >
            {viewAll}
          </Link>
        </div>
      </div>
    </Container>
  );
};
